(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["review-summary"] && !Shopify.designMode) return;
  try {
    const initializeProductReviewSummaries = async (root = document) => {
    const summaries = root.querySelectorAll('[data-product-review-summary]:not([data-loaded])');
    if (!summaries.length) return;

    try {
      const response = await fetch(summaries[0].dataset.reviewDataUrl);
      if (!response.ok) throw new Error('Review data unavailable');
      const data = await response.json();
      const reviews = Array.isArray(data.reviews) ? data.reviews : [];
      const total = reviews.reduce((sum, review) => sum + Number(review.rating || 0), 0);
      const average = reviews.length ? (total / reviews.length).toFixed(1) : '0';
      const mainReviews = document.querySelector('.photo-reviews');
      const customCount = Number.parseInt(mainReviews?.dataset.verifiedReviewCount || '', 10);
      const displayCount = mainReviews?.dataset.reviewCountMode === 'verified_total' && Number.isFinite(customCount) && customCount >= reviews.length ? customCount : reviews.length;

      summaries.forEach((summary) => {
        summary.dataset.loaded = 'true';
        summary.querySelector('[data-summary-rating]').textContent = average;
        summary.querySelector('[data-summary-count]').textContent = `${displayCount} Reviews`;
        summary.querySelectorAll('[data-summary-stars] svg').forEach((star, index) => {
          star.classList.toggle('is-filled', index < Math.round(Number(average)));
        });
        summary.setAttribute('aria-label', `${average} out of 5 stars from ${displayCount} reviews. Read customer reviews.`);
      });
    } catch (error) {
      summaries.forEach((summary) => { summary.hidden = true; });
    }
  };

  initializeProductReviewSummaries();
  document.addEventListener('shopify:section:load', (event) => initializeProductReviewSummaries(event.target));
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-product-review-summary]');
    if (!summary) return;
    const reviews = document.querySelector('#product-reviews');
    if (!reviews) return;
    event.preventDefault();
    reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.history.replaceState(null, '', '#product-reviews');
  });
  } catch(e) { console.error(e); }
})();

})();
